import React, { FunctionComponent } from 'react';
import { faUniversity } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '..';

const BrassIconAcademy: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faUniversity} />;

export { BrassIconAcademy };
